import { Col, Row } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';

import { useFormContext } from '../../../../components/forms/forms';
import { FormItemInputText } from '../../../../components/forms/basicFormElements';
import { DateTimeFormatNumeric } from '../../../../utils/dateFormatting';
import { useNewShipmentFlightInformationFormStyles } from '../../newShipment/NewShipmentFlightInformationForm.styles';

function FlightSummaryLabel({ label, value }) {
  const { styles } = useNewShipmentFlightInformationFormStyles();
  return (
    <div>
      <p className={styles.flightSummaryLabel}>{label}</p>
      <p className={styles.flightSummaryValue}>{value}</p>
    </div>
  );
}

export default function FlightSummary({ style }) {
  const { styles } = useNewShipmentFlightInformationFormStyles();
  const { formInstance } = useFormContext();
  const { formatMessage } = useIntl();
  const { flight } = formInstance.getFieldsValue(true);
  const {
    airline,
    flightNumber,
    departureDatetime,
    arrivalDatetime,
    departureAirport,
    arrivalAirport,
    arrivalCity,
    arrivalCountry,
  } = flight || {};

  return (
    <div
      className={styles.flightSummaryContainer}
      data-subject="flight-summary"
      style={style}
    >
      <Row>
        <Col span={3}>
          <FlightSummaryLabel
            label={formatMessage({ id: 'book.newAirRetrieval.search.flight' })}
            value={`${airline} ${flightNumber}`}
          />
        </Col>
        <Col span={3}>
          <FlightSummaryLabel
            label={formatMessage({ id: 'book.newAirRetrieval.search.route' })}
            value={`${departureAirport} → ${arrivalAirport}`}
          />
        </Col>
        <Col span={4}>
          <FlightSummaryLabel
            label={formatMessage({
              id: 'book.newAirRetrieval.search.departure',
            })}
            value={
              <DateTimeFormatNumeric
                value={moment(departureDatetime)}
                separator=" | "
              />
            }
          />
        </Col>
        <Col span={4}>
          <FlightSummaryLabel
            label={formatMessage({ id: 'book.newAirRetrieval.search.arrival' })}
            value={
              <DateTimeFormatNumeric
                value={moment(arrivalDatetime)}
                separator=" | "
              />
            }
          />
        </Col>
        <Col span={3}>
          <FlightSummaryLabel
            label={formatMessage({
              id: 'book.newAirRetrieval.search.arrivalAirport',
            })}
            value={arrivalAirport}
          />
        </Col>
        <Col span={4}>
          <FlightSummaryLabel
            label={formatMessage({ id: 'book.newAirRetrieval.search.city' })}
            value={arrivalCity}
          />
        </Col>
        <Col span={3}>
          <FlightSummaryLabel
            label={formatMessage({ id: 'book.newAirRetrieval.search.country' })}
            value={arrivalCountry}
          />
        </Col>
      </Row>
      <Row>
        <FormItemInputText
          name="airwayBillNumber"
          formItemComponentProps={{
            label: formatMessage({
              id: 'book.newAirRetrieval.airwayBillNumber',
            }),
          }}
          rules={[{ required: true }]}
        />
      </Row>
    </div>
  );
}
